import axios from 'axios'

function emailMessageIsValid(emailMessage) {
  return (
    !!emailMessage.recipientId &&
    !!emailMessage.senderEmail &&
    !!emailMessage.senderName &&
    !!emailMessage.messageBody
  )
}

export default async function(emailMessage, endpoint) {
  console.log({ emailMessage, endpoint })
  // Check to see if the parameters is valid
  if (!emailMessageIsValid(emailMessage)) {
    throw new Error(
      'The emailMessage object is invalid, cannot not send email.'
    )
  }

  try {
    await axios.post(endpoint, emailMessage)
  } catch (error) {
    if (error.response) {
      throw new Error(
        `A ${
          error.response.status
        } error occurred while attempting to send email: ${JSON.stringify(
          error.response.data
        )}`
      )
    } else {
      // Something happened in setting up the request and triggered an Error
      throw new Error(
        `A error occurred while attempting to send email: ${error.message}`
      )
    }
  }
}
